import * as React from 'react'
import 'react-dates/initialize'
import { IJsonResponse } from '../../../core/JsonApiSerializer'
import { reservationService } from '../../../core/services'
import { Chat, Channels } from '../reservations/parts'
import { ChatMembersList } from '../../organisms'

import MessageLayout from '../_layouts/messageLayout'

interface IProps {
  user: IJsonResponse
  other_user: IJsonResponse
  assign_guides: IJsonResponse
  messages: any
  conversation: any
  reservation: any
  receipt_id: number
  guest: IJsonResponse
  host: IJsonResponse
}

const Show: React.FC<IProps> = props => {
  const { data: user } = reservationService.getDataFromJson(props.user)
  const { data: guest } = reservationService.getDataFromJson(props.guest)
  const { data: host } = reservationService.getDataFromJson(props.host)
  const { data: parsedMessages } = reservationService.getDataFromJson(props.messages)
  const { data: parsedReservation } = reservationService.getDataFromJson(props.reservation)
  const [reservation, setReservation] = React.useState<any>(parsedReservation)

  const currentUserIsHost = !user.guest
  return (
    <MessageLayout
      user={user}
      host={host}
      receipt_id={props.receipt_id}
      reservation={reservation}
      setReservation={setReservation}
      pageName="check_reservation"
      Main={
        <Chat user={user} initMessages={parsedMessages} conversationId={props.conversation.id} />
      }
      Side={
        <>
          {host.agent && (
            <Channels page="check_reservation" user={user} reservation={reservation} />
          )}
          <ChatMembersList
            guide={host.guide ? host : null}
            guests={[guest]}
            agent={host.agent ? host : null}
          />
        </>
      }
    />
  )
}

export default Show
